import { warning } from '@/utils/alert'

export default {
  doStart () {
    this.showButtonProfile = true
  },
  doClose () {
    warning('Modulo em desenvolvimento.')
  },
  viewProfileProssional () {
    this.showButtonDetails = true
    this.showButtonProfile = false
    this.showDetailsModal1 = false
    this.showDetailsModal2 = true
  },
  viewDetailsProssional () {
    this.showButtonDetails = false
    this.showButtonProfile = true
    this.showDetailsModal1 = true
    this.showDetailsModal2 = false
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/resources/methods.js